import React from "react";
import { TextField } from "react-md";
const TextFieldBlack = (props) => {
  return (
    <TextField
      {...props}
      inputStyle={{
        ...(props.inputStyle || {}),
        color: "#000",
        fontWeight: "500",
        fontSize: "14px",
      }}
    />
  );
};
export default TextFieldBlack;
